import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {serialize} from "../../../helpers/utils/Utils";

export const errorLogsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchErrorLogs: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-error-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['errorLogs'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        resolveErrorById: build.mutation({
            query: ({orderId,orderLogId}) => {
                return {
                    url: `/ajax/orders-log-resolve/${orderId}/${orderLogId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['errorLogs','orderLogs'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Resolved", "Error Logs");
            },
        }),

    }),
});


export const {
    useSearchErrorLogsQuery,
    useResolveErrorByIdMutation,
} = errorLogsApi;